import { Close as CloseIcon, Person } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import React from "react";
import patterbackground from "../images/pattern.jpeg";

import { useTheme } from "@mui/material/styles";
import PhoneNumberField from "../../../../components/ui/PhoneNumberField";
import CustomTextField from "../../../../components/ui/Textfield";
import { tokens } from "../../../../theme";

interface WhatsAppModalProps {
  open: boolean;
  onClose: () => void;
  whatsappNumber: string;
  onNumberChange: (value: string) => void;
  fullName: string;
  onFullNameChange: (value: string) => void;
  onSubmit: () => void;
}

const ClientInfoModal: React.FC<WhatsAppModalProps> = ({
  open,
  onClose,
  whatsappNumber,
  onNumberChange,
  fullName,
  onFullNameChange,
  onSubmit,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <Box
        sx={{
          position: "relative",
          p: 3,
          bgcolor: "#614338",
          color: "white",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${patterbackground})`,
            backgroundRepeat: "repeat",
            backgroundSize: "contain",
            opacity: 0.1,
            zIndex: 0,
          }}
        />
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography variant="h4" fontWeight="bold">
            Get Your Quote
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{ opacity: 0.9, mt: 1, color: colors.primary[500] }}
        >
          Enter your WhatsApp number to receive a Personalised quote
        </Typography>
      </Box>
      <DialogContent sx={{ p: 3, mt: 1 }}>
        <CustomTextField
          fullWidth
          label="Enter Full Name*"
          placeholder="e.g. John Doe"
          value={fullName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onFullNameChange(e.target.value)
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 3 }}
        />

        <PhoneNumberField
          label="WhatsApp Number"
          placeholder="+263 77 123 4567"
          value={whatsappNumber}
          onChange={onNumberChange}
        />

        <Typography variant="caption" sx={{ color: "text.secondary", mb: 4 }}>
          We&apos;ll send your Personalised quote via WhatsApp
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={onClose}
            sx={{
              py: 1.5,
              borderRadius: 2,
              color: "text.primary",
              borderColor: "divider",
              boxShadow: 0,
              backgroundColor: colors.primary[800],
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={onSubmit}
            sx={{
              py: 1.5,
              borderRadius: 2,
              background: colors.primary[400],
              color: "white",
            }}
          >
            Continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ClientInfoModal;
